var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2653_13997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8273 4.72491C2.83649 4.72491 3.6546 3.9068 3.6546 2.89761C3.6546 1.88842 2.83649 1.07031 1.8273 1.07031C0.818109 1.07031 0 1.88842 0 2.89761C0 3.9068 0.818109 4.72491 1.8273 4.72491Z",
    fill: "#767D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8273 9.75225C2.83649 9.75225 3.6546 8.93414 3.6546 7.92495C3.6546 6.91577 2.83649 6.09766 1.8273 6.09766C0.818109 6.09766 0 6.91577 0 7.92495C0 8.93414 0.818109 9.75225 1.8273 9.75225Z",
    fill: "#767D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8273 14.93C2.83649 14.93 3.6546 14.1119 3.6546 13.1027C3.6546 12.0935 2.83649 11.2754 1.8273 11.2754C0.818109 11.2754 0 12.0935 0 13.1027C0 14.1119 0.818109 14.93 1.8273 14.93Z",
    fill: "#767D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74037 4.09227H15.6654C15.754 4.09227 15.8394 4.05692 15.9023 3.99409C15.9651 3.93126 16.0005 3.84598 16.0005 3.75718L16.0001 2.03627C16.0001 1.8513 15.85 1.70117 15.665 1.70117H5.74037C5.5554 1.70117 5.40527 1.8513 5.40527 2.03627V3.75718C5.40527 3.94215 5.55523 4.09227 5.74037 4.09227Z",
    fill: "#767D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.665 6.72656H5.74037C5.5554 6.72656 5.40527 6.87669 5.40527 7.06166V8.78256C5.40527 8.96754 5.5554 9.11766 5.74037 9.11766H15.6654C15.754 9.11766 15.8394 9.08231 15.9023 9.01948C15.9651 8.95665 16.0005 8.8712 16.0005 8.78256L16.0001 7.06166C16.0001 6.87669 15.8503 6.72656 15.665 6.72656Z",
    fill: "#767D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.665 11.9062H5.74037C5.5554 11.9062 5.40527 12.0564 5.40527 12.2413V13.9623C5.40527 14.1472 5.5554 14.2974 5.74037 14.2974H15.6654C15.754 14.2974 15.8394 14.262 15.9023 14.1992C15.9651 14.1363 16.0005 14.0509 16.0005 13.9623L16.0001 12.2413C16.0001 12.0564 15.8503 11.9062 15.665 11.9062Z",
    fill: "#767D92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2653_13997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default __webpack_public_path__ + "static/media/BulletList.3698256ee651cb08fa8db2036c7c202b.svg";
export { ForwardRef as ReactComponent };